import {
  APIReferenceAttributes,
  APIScopeData,
  BatchRequest,
} from '@ardoq/api-types';
import { actionCreator } from '@ardoq/rxbeach';
import { SelectOption } from '@ardoq/select';

export const referenceSelected = actionCreator<string | null>(
  '[ComponentOverview2025] REFERENCE_SELECTED'
);

export const selectedReferenceTabChanged = actionCreator<
  'reference' | 'component'
>('[ComponentOverview2025] SELECTED_REFERENCE_TAB_CHANGED');

export const startCreateReference = actionCreator<string>(
  '[ComponentOverview2025] START_CREATE_REFERENCE'
);

export const cancelCreateReference = actionCreator(
  '[ComponentOverview2025] CANCEL_CREATE_REFERENCE'
);

export const startCreateReferenceWithNewComponent = actionCreator(
  '[ComponentOverview2025] START_CREATE_REFERENCE_WITH_NEW_COMPONENT'
);

export const referencesFilterTermChanged = actionCreator<string>(
  '[ComponentOverview2025] REFERENCES_FILTER_TERM_CHANGED'
);

export const toggleGroupCollapsed = actionCreator<string>(
  '[ComponentOverview2025] TOGGLE_GROUP_COLLAPSED'
);

export type SetAllGroupsCollapsedPayload = {
  action: 'expand' | 'collapse';
  groupKeys: string[];
};

export const setAllGroupsCollapsed =
  actionCreator<SetAllGroupsCollapsedPayload>(
    '[ComponentOverview2025] SET_ALL_GROUPS_COLLAPSED'
  );

export const setReferenceSorting = actionCreator<'referenceName' | 'typeName'>(
  '[ComponentOverview2025] SET_REFERENCE_SORTING'
);

export const componentsToLinkToSelected = actionCreator<APIScopeData>(
  '[ComponentOverview2025] COMPONENTS_TO_LINK_TO_SELECTED'
);

export type CreateReferencesRequestedPayload = {
  batchRequest: BatchRequest;
  copComponentId: string;
};

export const createReferencesRequested =
  actionCreator<CreateReferencesRequestedPayload>(
    '[ComponentOverview2025] CREATE_REFERENCES_REQUESTED'
  );

export const createReferencesFailed = actionCreator(
  '[ComponentOverview2025] CREATE_REFERENCES_FAILED'
);

export type CreateReferencesSucceededPayload = {
  createdReferenceIds: string[];
  createdCopComponentIds: string[];
  createdReferences: APIReferenceAttributes[];
};

export const createReferencesSucceeded =
  actionCreator<CreateReferencesSucceededPayload>(
    '[ComponentOverview2025] CREATE_REFERENCES_SUCCEEDED'
  );

export const workspaceSelected = actionCreator<SelectOption<string> | null>(
  '[ComponentOverview2025] WORKSPACE_SELECTED'
);

export const newComponentNameUpdated = actionCreator<string>(
  '[ComponentOverview2025] NEW_COMPONENT_NAME_UPDATED'
);

export const referenceCreationHighlightEnded = actionCreator<string[]>(
  '[ComponentOverview2025] REFERENCE_CREATION_HIGHLIGHT_ENDED'
);

export const removeReference = actionCreator<{
  referenceId: string;
  copComponentId: string;
}>('[ComponentOverview2025] REMOVE_REFERENCE');

export const removeReferenceSucceeded = actionCreator(
  '[ComponentOverview2025] REMOVE_REFERENCE_SUCCEEDED'
);

export const toggleHideEmptyReferenceGroups = actionCreator(
  '[ComponentOverview2025] TOGGLE_HIDE_EMPTY_REFERENCE_GROUPS'
);
